// extracted by mini-css-extract-plugin
export var circle = "_4n-2";
export var icon = "_4n-a";
export var iconHighlight = "_4n-0";
export var lg = "_4n-8";
export var md = "_4n-7";
export var outline = "_4n-4";
export var sm = "_4n-6";
export var square = "_4n-1";
export var xl = "_4n-9";
export var xs = "_4n-5";
export var xxs = "_4n-3";